window.adobeDataLayer = window.adobeDataLayer || [];
var data;
	$.ajax({
	  type: "GET",  
	  url: window.__international_csv_file,
	  dataType: "text",       
	  success: function(response)  
	  {
		data = $.csv.toArrays(response);
		international_country_values(data);
        

	  }   
	});


  function international_country_values(data) {
    var html = '';
    var listcountry = '';
    var data_attr = '';
    var data_list = [];
     	
    var data_attrlist = [];
    var data_attribute_html = [];
    var SelectOptions = '<option value="Select a country">Select a country</option>';
    var j=0;
    
    //if( data_list
    
    $.each(data, function( index, row ) {
      	
      if ( index != 0 ){
    	data_attribute_html[row[2]] = [""];
         
        data_list[row[2]] = [""];
      } 
     
    });

    
      if(typeof(data[0]) === 'undefined') {
        return null;
      } else {

		$.each(data, function( index, row ) {
		  //bind header
         
		  if(index == 0) {
            
		  } else {
            
           
		
			$.each(row, function( index, colData ) {
				
              
              if(index == 2){ 
                
                listcountry = listcountry + colData + ',';
                
                var country_array = listcountry.split(",");
                let uniqueChars = [...new Set(country_array)];
                uniqueChars = uniqueChars.sort();
                
                for( var i=0; i<uniqueChars.length; i++){
              
                
                  if( row[2] == uniqueChars[i] ){

                      data_attribute_html[row[2]][j] = "<record><name>"+row[0]+"</name><geo>"+row[1]+"</geo><country>"+row[2]+"</country><address>"+row[8]+"</address><address2>"+row[9]+"</address2><email>"+row[3]+"</email><phone>"+row[5]+"</phone></record>";
                  
                    data_list[row[2]][j] =  data_attribute_html[row[2]][j];
                    
                    j++;
                  }
                }
                
              }
               
				 
			});
			 
		  }
		});
         
        
        var country_array = listcountry.split(",");
        let uniqueChars = [...new Set(country_array)];
        uniqueChars = uniqueChars.sort();

        var tttt = [];
        var parent_xml = '';
        
        for( var i=0; i<uniqueChars.length; i++){
         

        data_list[uniqueChars[i]] += "</googlelocations>";
          
          if( uniqueChars[i] != ''  ){
			 
            	
              //if( uniqueChars[2] ){
                 parent_xml = '<googlelocations>';
             // }
            
               SelectOptions = SelectOptions + '<option value="'+uniqueChars[i]+'" data-val="'+parent_xml+data_list[uniqueChars[i]]+'" >'+ uniqueChars[i] + '</option>';
			   
               $('#international_values').html(SelectOptions);
          }
           
        }
         
	  }
	}


var storeCount = 0
var newIntstores = [];
var newIntstores_data = [];


function selectCountry(value) {
  
  jQuery('#country-store-list').empty();
  var xml = $("#international_values option:selected").attr('data-val');
  var array = $(xml).find("record").map(function() {
    return this.outerHTML; // to get the techjob
  }).get();
 
  newIntstores = [];
  // MapDefaultVal = false;
  newIntstores_data = [];
  newIntstores_digital_data = [];
                   let html = "<div class='retailer-store-heading d-flex justify-content-between mb-2'>";
                   html +=  "<p class='mb-0'>"+ array.length +" Retailers Near You</p>";
  				   if ( array.length > 10 ){
                     // html +=    "<p class='mb-0'>10 of "+array.length+" Retailers</p>";
                   }else{
                   }
                   html +=  "</div>";
                   html += "<ul class='stores-css'>";
  let cnt = 0;
  let allArray = [];
        for(i=0;i<array.length;i++)
        { 
          var latlong =$( array[i] ).find("geo").text();
          var name =$( array[i] ).find("name").text();
          var country =$( array[i] ).find("country").text();
          var address =$( array[i] ).find("address").text();
          var address2 =$( array[i] ).find("address2").text();
          var phone =$( array[i] ).find("phone").text();
          var email =$( array[i] ).find("email").text();   
          allArray.push({"name": name , "country": country , "address": address , "phone": phone ,"email": email});
             let content = '<div class="marker-content"><b class="name"> ' + name + '</b><p class="address">' + address + ','+country+'<br>';

               
              content += '</div>';
                      
              newIntstores_data[cnt] =  content;
              newIntstores[cnt] = {
                      lat: parseFloat(latlong.split(",")[0]),
                      lng: parseFloat(latlong.split(",")[1])
                    };
              
                 cnt++;         
          
          html += '<li style="display:flex;">';
                html += '<div class="stores-info dealer-card-body">';
                html += '<div class="stores-info-content">';
                html += '<h4>' + name + '</h4>';
                html += '<div class="stores-content">';
                html += '<ul>';
                html += '<li>' + address + '</li>';
                html += '</ul>';
              
                html += '</div>';
          		
          		if( phone != '' ){
                	html += '<p><b>Phone </b> '+ phone +'</p>';
                }
          		if( email != '' ){
          			html += '<p><b>Email </b> '+ email +'</p>';
                }
                
        		
          		html += '</div></div></li>';
        
          
          //updateRetailerLocator2(array.length);         
          /* jQuery('#' + i).css("background-image", "url(" + icon +")");
                     attachEvents(i); */
           
        }
  
  		html += "</ul>";
  		jQuery('#country-store-list').append(html);

        adobeDataLayer.push({
          'event': 'search',
          'search': {
            'filters': [{
              'type': 'Country',
              'value': value
            }],
            'numberOfResults': allArray.length,
            'results': allArray,
            'searchType':'find a retailer'
          }
        })
  
        //jQuery(".totalResults").val(array.length);
            initernationMap();
      }
   
let map2;
let markersInt = [];


function initernationMap() {
  
  deleteIntMarkers();
  
   
  if (typeof newIntstores !== 'undefined')
  {   
        
      if(newIntstores.length > 0 ){ 
        
          const haightAshbury = { lat: newIntstores[0].lat, lng: newIntstores[0].lng };
          map2 = new google.maps.Map(document.getElementById("international_map"), {
            zoom: 4,
            center: haightAshbury
          });
        
      }
    	
      if ( newIntstores.length == 0 ){
       	
       const initer_haightAshbury = { lat: 0, lng: 0 };
        map2 = new google.maps.Map(document.getElementById("international_map"), {
          zoom: 2,
          center: initer_haightAshbury
        });
  

      }

      // Adds a marker at the center of the map.
      for(let i = 0; i< newIntstores.length; i++){
        addIntMarker(newIntstores[i],i,newIntstores_data[i]);
      }
  
  }
  
}
 
   let lastOpenedInfoWindowInt = "";

// Adds a marker to the map and push to the array.
function addIntMarker(location,index,content) {
  let marker1 = "";
  
  switch(index) {
      case 0:
        marker1 = new google.maps.Marker({
          position: location,
          map: map2,
          icon:{
        url: "https://cdn.shopify.com/s/files/1/0558/0652/5639/t/2/assets/base-pin_purple.png", 
        scaledSize: new google.maps.Size(30, 45), // size
        },
        });
             markersInt.push(marker1);
        break;
      case 1:
        marker1 = new google.maps.Marker({
          position: location,
          map: map2,
          icon:{
        url: "https://cdn.shopify.com/s/files/1/0558/0652/5639/t/2/assets/base-pin_purple.png", 
        scaledSize: new google.maps.Size(30, 45), // size
        },
        });
         markersInt.push(marker1);
        break;
       case 2:
        marker1 = new google.maps.Marker({
          position: location,
          map: map2,
          icon:{
        url: "https://cdn.shopify.com/s/files/1/0558/0652/5639/t/2/assets/base-pin_purple.png", 
        scaledSize: new google.maps.Size(30, 45), // size
        },
          
        });
             markersInt.push(marker1);
        break;
       case 3:
        marker1 = new google.maps.Marker({
          position: location,
          map: map2,
          icon:{
        url: "https://cdn.shopify.com/s/files/1/0558/0652/5639/t/2/assets/base-pin_purple.png", 
        scaledSize: new google.maps.Size(30, 45), // size
        },
          
        });
             markersInt.push(marker1);
        break;
       case 4:
        marker1 = new google.maps.Marker({
          position: location,
          map: map2,
          icon:{
        url: "https://cdn.shopify.com/s/files/1/0558/0652/5639/t/2/assets/base-pin_purple.png", 
        scaledSize: new google.maps.Size(30, 45), // size
        },
          
        });
             markersInt.push(marker1);
        break;
      default:
        marker1 = new google.maps.Marker({
          position: location,
          map: map2,
          icon:{
        url: "https://cdn.shopify.com/s/files/1/0558/0652/5639/t/2/assets/base-pin_purple.png", 
        scaledSize: new google.maps.Size(30, 45), // size
        },
        });
             markersInt.push(marker1);
  }
  const infowindow = new google.maps.InfoWindow({
    content: content,
  });
  
  marker1.addListener("click", () => {
    closeLastOpenedInfoWindowInt();
    infowindow.open(map2, marker1);
  lastOpenedInfoWindowInt = infowindow;
  });
  
 
}

function closeLastOpenedInfoWindowInt() {
    if (lastOpenedInfoWindowInt) {
        lastOpenedInfoWindowInt.close();
    }
}

// Sets the map on all markers in the array.
function setMapOnAllInt(map2) {
  for (let i = 0; i < markersInt.length; i++) {
    markersInt[i].setMap(map2);
  }
}

// Removes the markers from the map, but keeps them in the array.
function clearIntMarkers() {
  setMapOnAllInt(null);
}

// Shows any markers currently in the array.
function showIntMarkers() {
  setMapOnAllInt(map);
}

// Deletes all markers in the array by removing references to them.
function deleteIntMarkers() {
  clearIntMarkers();
  markersInt = [];
}
//initernationMap();
//]]>
jQuery(document).ready(function($){
 // $('#international_values').find('option[value="Select a country"]').attr('selected','selected');
  initernationMap();
});